const { isFreezer } = require('../deviceManagement/cabinetUtils/utils');

const _13digitBarcode = (barcodeType, barcode) => {
    if (!barcode) return;
    if (barcode.length === 13) return barcode;
    // always make the barcode having the length 13, if barcodeType missing
    if (!barcodeType) {
        return barcode.padStart(13, 0);
    }

    switch (barcodeType) {
        case 'EAN-13':
            return barcode;
        case 'EAN-8':
            return '00000' + barcode;
        case 'UPC-A':
            return '0' + barcode;
        default:
            return barcode; // To be backwards compatible, products that do not have barcode types are treated as having a EAN-13 barcode type
    }
};

/**
 * A help text that appears when mouse is hover over action buttons
 * @param {string} type pdf | excel | add | delete
 * @returns title text
 */
const getHelperTitleText = (type, t) => {
    const titles = {
        pdf: t('exportPDFHelp'),
        excel: t('exportExcelHelp'),
        add: t('addPlanHelp'),
        delete: t('deletePlanHelp'),
        generatePlans: t('generatePlansHelp'),
    };

    return titles[type];
};

const defaultPlanogramData = {
    shelvesCount: 5,
    shelves: [
        {
            shelf: 1,
            slotCount: 5,
            productData: [],
        },
        {
            shelf: 2,
            slotCount: 5,
            productData: [],
        },
        {
            shelf: 3,
            slotCount: 5,
            productData: [],
        },
        {
            shelf: 4,
            slotCount: 5,
            productData: [],
        },
        {
            shelf: 5,
            slotCount: 5,
            productData: [],
        },
    ],
};

const imageUrlToBase64 = async (url, productId, cabinetName, target = null) => {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onload = () => {
                        const base64data = reader.result;
                        resolve({ imageUrl: base64data, id: productId, cabinetName, target });
                    };
                });
            })
            .catch(e => {
                console.log(e);
                resolve({ imageUrl: '', id: productId, cabinetName, target });
            });
    });
};

/**
 * check if the cabinet is a scale or hybrid cabinet
 * @param {*} cabinetData cabinet object
 * @returns boolean
 */
const isScaleCabinet = cabinetData => {
    const deviceSubType = cabinetData.deviceSubType;

    if (deviceSubType === 'IF2' || deviceSubType === 'IF3' || isFreezer(cabinetData)) return false;

    const splitType = deviceSubType.split('_')[3];

    if (splitType && (splitType === 'S1' || splitType === 'R1S1')) return true;
    return false;
};

/**
 * check if the cabinet is a scale2 (device-weight-service lanes) or hybrid rfid + scale2 cabinet.
 * Kept apart from isScaleCabinet on purpose: scale1 cabinets get their shelves from the CDN shelf config,
 * scale2 cabinets get their planogram from the cabinet itself.
 * @param {*} cabinetData cabinet object
 * @returns boolean
 */
const isScale2Cabinet = cabinetData => {
    const deviceSubType = cabinetData && cabinetData.deviceSubType;
    if (!deviceSubType || typeof deviceSubType !== 'string') return false;
    const splitType = deviceSubType.split('_')[3];
    return splitType === 'S2' || splitType === 'R1S2';
};

/**
 * planogram shelf types drawn as scale shelves (one product per slot, no slot editing)
 * @param {*} type shelf type
 * @returns boolean
 */
const isScaleShelfType = type => type === 'scale1' || type === 'scale2';

/**
 * get the self config from cdn
 * @returns
 */
const getCabinetShelfConfig = async () => {
    const url = 'https://cdn.selflystore.com/shelf-configs/shelf-configs.json';
    return fetch(url)
        .then(response => response.json())
        .then(data => data)
        .catch(err => {});
};

/**
 * get the cabinet settings and parse the data
 * @param {*} deviceCode
 * @param {*} keycloakRef
 * @param {*} shelfConfig
 * @returns selfConfig
 */
const getCabinetSettings = async (deviceCode, keycloakRef, shelfConfig) => {
    const graphqlQuery = `{device(code: "${deviceCode}") { alternativeIds } }`;
    const url = `${process.env.REACT_APP_API_URL}/v4/graphql`;

    return keycloakRef.current.updateToken(30)
        .then(() => fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${keycloakRef.current.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: graphqlQuery }),
        }))
        .then(response => response.json())
        .then(data => {
            const responseData = data.data;
            const settings = responseData?.device?.alternativeIds;
            if (settings && settings.shelfConfigId && settings.shelfConfigId in shelfConfig) {
                const shelvesData = shelfConfig[settings.shelfConfigId].shelfConfig;

                const shelves = shelvesData.map(shelf => ({
                    shelf: shelf.shelf,
                    type: shelf.type,
                    slots: shelf.slots
                        ? shelf.slots.map(slot => ({
                            slot: slot.slot,
                            products: [],
                        }))
                        : [],
                }));
                return { shelvesCount: shelvesData.length, shelves };
            } else {
                return {};
            }
        })
        .catch(error => {
            return {};
        });
};

module.exports = {
    _13digitBarcode,
    getHelperTitleText,
    defaultPlanogramData,
    imageUrlToBase64,
    isScaleCabinet,
    isScale2Cabinet,
    isScaleShelfType,
    getCabinetShelfConfig,
    getCabinetSettings,
};
